import React from "react";
import { array, object, string } from "prop-types";
import { WithLazy, Link } from "@quintype/components";
import CardImage from "../../../atoms/cardimage";

import "./hero-image.m.css";

const HeroImage = ({ story, aspectRatio, imageType }) => {
  if (!story["hero-image-s3-key"]) {
    return null;
  }

  return (
    <WithLazy margin="20px">
      {() => (
        <div styleName="hero-image">
          {story?.["hero-image-hyperlink"] ? (
            <Link href={story?.["hero-image-hyperlink"]}>
              <CardImage
                story={story}
                showMetaData={false}
                aspectRatio={aspectRatio}
                imageType={imageType}
                widths={[400, 900]}
                sizes="(max-width: 1024px) 25vw, 100vw"
                showAlternateImage
                showCameraIcon={false}
              />
            </Link>
          ) : (
            <CardImage
              story={story}
              showMetaData={false}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={[400, 900]}
              sizes="(max-width: 1024px) 25vw, 100vw"
              showAlternateImage
              showCameraIcon={false}
            />
          )}
          {story["hero-image-caption"] && (
            <div styleName="caption-container">
              <figcaption styleName="caption" dangerouslySetInnerHTML={{ __html: story["hero-image-caption"] }} />
              {story["hero-image-attribution"] && (
                <span
                  styleName="attribute"
                  dangerouslySetInnerHTML={{ __html: `${story["hero-image-attribution"]}` }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </WithLazy>
  );
};
HeroImage.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9"
};

HeroImage.propTypes = {
  story: object,
  aspectRatio: array,
  imageType: string
};

export default HeroImage;
